import { Component } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
	selector: 'app-global-message',
	templateUrl: './global-message.component.html',
	styleUrls: ['./global-message.component.scss']
})
export class GlobalMessageComponent {
	toasts = this.commonService.toasts;

	constructor(
		public commonService: CommonService
	) { }

	removeToast(index: number): void {
		this.commonService.removeToast(index);
	}
}
